// extracted by mini-css-extract-plugin
export default {"bookNowBtn":"BookNowBtn_bookNowBtn__BLZBT","change-color-on-hover":"BookNowBtn_change-color-on-hover__XtFKT","button":"BookNowBtn_button__THfxD"};